﻿import { FileContainer } from "../components";

export function getRelativeFolderPath(file: File) {
    const path = (file as unknown as { path: string }).path || file.webkitRelativePath;
    const lastSlash = path.lastIndexOf("/");
    return path.substring(1, Math.max(lastSlash, 1));
}

export function getUniqueFolderPaths<E>(fileContainers: FileContainer<E>[]) {
    const folderPaths = fileContainers.reduce((paths, fileContainer) => {
        const folderPath = fileContainer.relativeFolderPath;
        if (folderPath) {
            paths.add(folderPath);
        }
        return paths;
    }, new Set<string>());

    return Array.from(folderPaths);
}
